export const secondMattingFactorialPrice = 0.9;